import React from "react";

import Link from "next/link";
import PropTypes from "prop-types";
import { Nav } from "react-bootstrap";
import styled from "styled-components";

function StyledLink({ as, children, className, href, onClick }) {
  return (
    <Link as={as} href={href} passHref scroll={false} legacyBehavior>
      <StyledNavLink className={className} onClick={onClick}>
        {children}
      </StyledNavLink>
    </Link>
  );
}

const StyledNavLink = styled(Nav.Link)`
  text-decoration: none !important;
  transition: color 0.2s ease-in-out !important;
  font-weight: bold;
  font-size: 1rem;
  color: white !important;
  position: absolute;
  left: 3rem;
  bottom: 6rem;

  &.active {
    color: ${({ theme }) => theme.primaryColor} !important;
  }

  &:hover {
    color: ${({ theme }) => theme.negativeTextColor} !important;
  }

  &:focus {
    color: ${({ theme }) => theme.negativeTextColor} !important;
    border: 0 !important;
  }
`;

export default StyledLink;

StyledLink.propTypes = {
  as: PropTypes.string,
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

StyledLink.defaultProps = {
  as: null,
  className: null,
  href: null,
};
